/* eslint-disable max-lines-per-function */
import React from 'react';
import { Formik } from 'formik';
import { validacaoFormImagens } from '../helpers/validacao';
import { FormCadastrarMidia } from '../components/FormCadastrarMidia.js';

export function CadastrarMidia({
    setRecarregarDataTable,rowSelecionada, setOpenModalCadastro, setMensagem, setDados }) {
    const initialValues = {
        descricao: ''        
    };

    return (
        <div>            
            <Formik
                initialValues={initialValues}
                validationSchema={validacaoFormImagens}
               
            >                
                <FormCadastrarMidia
                    setOpenModalCadastro={setOpenModalCadastro}
                    setMensagem={setMensagem}
                    rowSelecionada={rowSelecionada} 
                    setRecarregarDataTable={setRecarregarDataTable} 
                    setDados={setDados} nomebotao={'Cadastrar'}></FormCadastrarMidia>
            </Formik>
        </div>
    );
}
